import { LoginForm } from "./login-form";
import { Container, Center, Stack, Group, ThemeIcon, Text, Anchor } from '@mantine/core';

export function LoginPage() {
  return (
    <Center h="100vh" bg="var(--mantine-color-body)">
      <Container size="xs" w="100%">
          <LoginForm />
      </Container>
    </Center>
  );
}